module.exports = __webpack_public_path__ + "img/today_new_icon.a7605d7d.png";